<template>
  <Teleport to="body">
    <div v-if="visible" class="captcha-overlay" @click.self="close">
      <div class="captcha-modal">
        <button class="captcha-close" @click="close" aria-label="Close">&times;</button>
        <div class="captcha-icon">
          <i class="fa-brands fa-whatsapp"></i>
        </div>
        <h3 class="captcha-title">{{ $t('captcha.title') }}</h3>
        <p class="captcha-question">{{ question }}</p>
        <input
          ref="inputRef"
          v-model="answer"
          type="number"
          class="captcha-input"
          :placeholder="$t('captcha.placeholder')"
          @keyup.enter="submit"
          inputmode="numeric"
        />
        <p v-if="error" class="captcha-error">{{ $t('captcha.error') }}</p>
        <button class="captcha-submit" @click="submit">
          <i class="fa-brands fa-whatsapp"></i>
          {{ $t('captcha.submit') }}
        </button>
      </div>
    </div>
  </Teleport>
</template>

<script>
const WA_URL = atob('aHR0cHM6Ly93YS5tZS8zNDY2NzU4NzUxMg==');

export default {
  name: 'WhatsAppCaptcha',
  data() {
    return {
      visible: false,
      a: 0,
      b: 0,
      op: '+',
      answer: '',
      error: false,
    };
  },
  computed: {
    question() {
      return `${this.$t('captcha.question')} ${this.a} ${this.op} ${this.b}?`;
    },
    correctAnswer() {
      return this.op === '+' ? this.a + this.b : this.a - this.b;
    },
  },
  methods: {
    open() {
      this.a = Math.floor(Math.random() * 9) + 1;
      this.b = Math.floor(Math.random() * 9) + 1;
      this.op = Math.random() > 0.5 ? '+' : '-';
      if (this.op === '-' && this.b > this.a) {
        [this.a, this.b] = [this.b, this.a];
      }
      this.answer = '';
      this.error = false;
      this.visible = true;
      this.$nextTick(() => this.$refs.inputRef?.focus());
    },
    close() {
      this.visible = false;
      this.error = false;
      this.answer = '';
    },
    submit() {
      if (parseInt(this.answer, 10) === this.correctAnswer) {
        this.close();
        window.open(WA_URL, '_blank', 'noopener,noreferrer');
      } else {
        this.error = true;
        this.answer = '';
        this.$nextTick(() => this.$refs.inputRef?.focus());
      }
    },
  },
};
</script>

<style scoped>
.captcha-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.15s ease;
}

.captcha-modal {
  background: #fff;
  border-radius: 12px;
  padding: 36px 32px 28px;
  width: 100%;
  max-width: 360px;
  text-align: center;
  position: relative;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  animation: slideUp 0.2s ease;
}

.captcha-close {
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  font-size: 24px;
  line-height: 1;
  color: #999;
  cursor: pointer;
  padding: 0;
}
.captcha-close:hover {
  color: #333;
}

.captcha-icon {
  font-size: 40px;
  color: #25D366;
  margin-bottom: 8px;
}

.captcha-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 16px;
}

.captcha-question {
  font-size: 20px;
  font-weight: 500;
  color: #333;
  margin: 0 0 14px;
}

.captcha-input {
  width: 100%;
  padding: 10px 14px;
  border: 2px solid #ddd;
  border-radius: 8px;
  font-size: 18px;
  text-align: center;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
  -moz-appearance: textfield;
}
.captcha-input::-webkit-outer-spin-button,
.captcha-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.captcha-input:focus {
  border-color: #25D366;
}

.captcha-error {
  color: #e53935;
  font-size: 13px;
  margin: 8px 0 0;
}

.captcha-submit {
  margin-top: 20px;
  width: 100%;
  padding: 12px;
  background: #25D366;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.2s;
}
.captcha-submit:hover {
  background: #128C7E;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { transform: translateY(16px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
</style>
